module.exports = __webpack_public_path__ + "img/about-photo1.0333a649.jpg";